import OfficialInformationForm from './OfficialInformationForm';

export default OfficialInformationForm;
